import { connect } from 'react-redux';
import withCurrentPath from 'Seo/hocs/with_current_path';
import AlternateLanguagesContainer from './alternate_languages_container';

export default withCurrentPath()(connect()(AlternateLanguagesContainer));
